import React, { useState, useEffect } from "react";
import axios from "axios";
import "./App.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronRight,
  faChevronLeft,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

library.add(faChevronRight, faChevronLeft);

function App() {
  // todo: Make an empty array
  const [searchResults, setSearchResults] = useState(undefined);
  // todo: set instead of results.pagination.whatever
  // const [pagResults, setPagResults] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  //Pagination
  const [loading, setLoading] = useState(false);
  const [pageNum, setPageNum] = useState(1);

  useEffect(() => {
    if (!loading) {
      return;
    }
    const getApi = async () => {
      const url = `https://scmq7n.a.searchspring.io/api/search/search.json?siteId=scmq7n&q=${searchTerm}&resultsFormat=native&page=${pageNum}`;
      const res = await axios.get(url);
      // todo: res.data.results
      setSearchResults(res.data);
      // todo: setPagResults: res.data.pagination
      setLoading(false);
    };
    getApi();
  }, [pageNum, searchTerm, loading]);

  const queryTerm = (e) => {
    setSearchTerm(e.target.value);
    setPageNum(1);
  };

  // handle "enter" keypress
  const handleKeypress = (event) => {
    if (event.key === "Enter") {
      setLoading(true);
    }
  };

  const prevPage = () => {
    if (pageNum === 1) {
      return;
    }
    setPageNum(pageNum - 1);
    setLoading(true);
  };
  const nextPage = () => {
    setPageNum(pageNum + 1);
    setLoading(true);
  };
  // todo: make component and put into the next return
  if (!searchResults || searchResults.results.length === 0) {
    return (
      <main>
        <div className="mobile-wave-padding"></div>
        <svg
          className="wave position-relative"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
        >
          <path
            fill="#d0bc56"
            fill-opacity="1"
            d="M0,224L40,208C80,192,160,160,240,160C320,160,400,192,480,213.3C560,235,640,245,720,229.3C800,213,880,171,960,149.3C1040,128,1120,128,1200,133.3C1280,139,1360,149,1400,154.7L1440,160L1440,0L1400,0C1360,0,1280,0,1200,0C1120,0,1040,0,960,0C880,0,800,0,720,0C640,0,560,0,480,0C400,0,320,0,240,0C160,0,80,0,40,0L0,0Z"
          ></path>
        </svg>
        <div className="container flex justify-content-start">
          <div className="row text-start">
            {searchResults ? (
              <div>
                {searchResults.results.length === 0 ? (
                  <h2>We can't seem to find that...</h2>
                ) : (
                  <div></div>
                )}
              </div>
            ) : (
              <div>
                <h2>Come check out our selection!</h2>
              </div>
            )}
          </div>
          <div className="d-flex row justify-content-start mt-3">
            <div className="d-flex col landing-input justify-content-start pl-3">
              <label>
                <input
                  id="textInput"
                  className="pr-0 col text-center input-field"
                  type="text"
                  search="search"
                  placeholder="What are you looking for?"
                  onChange={queryTerm}
                  onKeyPress={(e) => handleKeypress(e)}
                />
              </label>
              <input
                id="inputButton"
                className="btn border border-secondary"
                type="submit"
                value="submit"
                onClick={() => setLoading(true)}
              />
            </div>
          </div>
        </div>
      </main>
    );
  }

  return (
    <div>
      <svg
        className="wave position-relative"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
      >
        <path
          fill="#d0bc56"
          fill-opacity="1"
          d="M0,224L40,208C80,192,160,160,240,160C320,160,400,192,480,213.3C560,235,640,245,720,229.3C800,213,880,171,960,149.3C1040,128,1120,128,1200,133.3C1280,139,1360,149,1400,154.7L1440,160L1440,0L1400,0C1360,0,1280,0,1200,0C1120,0,1040,0,960,0C880,0,800,0,720,0C640,0,560,0,480,0C400,0,320,0,240,0C160,0,80,0,40,0L0,0Z"
        ></path>
      </svg>

      <div className="container">
        {/* Search bar */}
        <div className="d-flex row mt-3 px-4 results-searchbar">
          <label className="d-flex px-0 mb-3 col-4">
            <input
              className="col text-center input-field"
              id="textInput"
              type="text"
              search="search"
              placeholder="What are you looking for?"
              onChange={queryTerm}
              onKeyPress={(e) => handleKeypress(e)}
            />
            <input
              id="inputButton"
              className="btn border border-secondary"
              type="submit"
              value="search"
              onClick={() => setLoading(true)}
            />
          </label>
        </div>

        {/* Nav buttons and page count */}
        {/* Does not show prev page button if one page 1, otherwise it does */}
        <div className="row mt-3 mb-3">
          {/* If the page we are on is the only page in the results, do not show prev page numbers, otherwise do */}
          <div className="col">
            {searchResults.pagination.currentPage ===
              searchResults.pagination.totalPages &&
            searchResults.pagination.currentPage > 1 ? (
              <div className="row">
                <div className="col">
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    onClick={prevPage}
                    className="text-muted fa-icon"
                    size="2x"
                  />
                </div>
                <div className="col text-muted fa-icon">
                  <h6>{searchResults.pagination.previousPage}</h6>
                </div>
                <div className="col">
                  <h5 className="highlight-page">
                    {searchResults.pagination.currentPage}
                  </h5>
                </div>
              </div>
            ) : (
              <div className="row mb-3">
                {searchResults.pagination.currentPage > 1 ? (
                  <div className="col d-flex justify-content-start">
                    <FontAwesomeIcon
                      icon={faChevronLeft}
                      onClick={prevPage}
                      className="text-muted fa-icon"
                      size="2x"
                    />
                  </div>
                ) : (
                  <div></div>
                )}
                {searchResults.pagination.previousPage === 0 ? (
                  <div></div>
                ) : (
                  <div className="col text-center text-muted fa-icon">
                    <h6>{searchResults.pagination.previousPage}</h6>
                  </div>
                )}
                <div className="col text-center">
                  <div className="d-flex justify-content-center">
                    <h5 className="highlight-page">
                      {searchResults.pagination.currentPage}
                    </h5>
                  </div>
                </div>
                {searchResults.pagination.totalPages ===
                searchResults.pagination.currentPage ? (
                  <div></div>
                ) : (
                  <div className="col text-center text-muted fa-icon">
                    <h6>{searchResults.pagination.nextPage}</h6>
                  </div>
                )}
                {searchResults.pagination.totalPages ===
                  searchResults.pagination.currentPage &&
                searchResults.pagination.currentPage === 1 ? (
                  <div></div>
                ) : (
                  <div className="col d-flex justify-content-end">
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      onClick={nextPage}
                      className="text-muted fa-icon"
                      size="2x"
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Product Grid */}

        <div className="row">
          {searchResults.results.map((el) => (
            <div className="col justify-content-center mb-3" key={el.id}>
              <div className="d-flex justify-content-center mb-1">
                <img src={el.thumbnailImageUrl} alt={el.title[0]} />
              </div>
              <div className="text-center">
                <span>{el.title[0]}</span>
              </div>
              <div className="container">
                <div className="row">
                  <div className="text-end col">
                    {Number(el.msrp) > Number(el.price) ? (
                      <span className="crossed-out">MSRP: ${el.msrp}</span>
                    ) : (
                      <span>MSRP: ${el.msrp}</span>
                    )}
                  </div>
                  <div className="text-start col">
                    <span>Price: ${el.price}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* Nav buttons and page count */}
        {/* Does not show prev page button if one page 1, otherwise it does */}
        <div className="row mt-3 mb-3">
          {/* If the page we are on is the only page in the results, do not show prev page numbers, otherwise do */}
          <div className="col">
            {searchResults.pagination.currentPage ===
              searchResults.pagination.totalPages &&
            searchResults.pagination.currentPage > 1 ? (
              <div className="row">
                <div className="col">
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    onClick={prevPage}
                    className="text-muted fa-icon"
                    size="2x"
                  />
                </div>
                <div className="col text-muted fa-icon">
                  <h6>{searchResults.pagination.previousPage}</h6>
                </div>
                <div className="col">
                  <h5 className="highlight-page">
                    {searchResults.pagination.currentPage}
                  </h5>
                </div>
              </div>
            ) : (
              <div className="row mb-3">
                {searchResults.pagination.currentPage > 1 ? (
                  <div className="col d-flex justify-content-start">
                    <FontAwesomeIcon
                      icon={faChevronLeft}
                      onClick={prevPage}
                      className="text-muted fa-icon"
                      size="2x"
                    />
                  </div>
                ) : (
                  <div></div>
                )}
                {searchResults.pagination.previousPage === 0 ? (
                  <div></div>
                ) : (
                  <div className="col text-center text-muted fa-icon">
                    <h6>{searchResults.pagination.previousPage}</h6>
                  </div>
                )}
                <div className="col text-center">
                  <div className="d-flex justify-content-center">
                    <h5 className="highlight-page">
                      {searchResults.pagination.currentPage}
                    </h5>
                  </div>
                </div>
                {searchResults.pagination.totalPages ===
                searchResults.pagination.currentPage ? (
                  <div></div>
                ) : (
                  <div className="col text-center text-muted fa-icon">
                    <h6>{searchResults.pagination.nextPage}</h6>
                  </div>
                )}
                {searchResults.pagination.totalPages ===
                  searchResults.pagination.currentPage &&
                searchResults.pagination.currentPage === 1 ? (
                  <div></div>
                ) : (
                  <div className="col d-flex justify-content-end">
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      onClick={nextPage}
                      className="text-muted fa-icon"
                      size="2x"
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
